module.exports = __webpack_public_path__ + "assets/img/A2.af647af6.png";